/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CertifiedPartner":"CertifiedPartner_dbVHf","wrapper":"wrapper_XdL3+","textWrapper":"textWrapper_rrVVE"};